import React from 'react';
import { Typography, Box, useMediaQuery, useTheme } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { StepButtonBar } from '../OtherRequirementWizard/StepButtonBar';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';

const PRIMARY = '#c4122f';

interface DisconnectStep2PreviewProps {
  selectedRequirement: { id: number; name: string } | null;
  selectedCompanyUnits: any[];
  onRemove: () => void;
  onBack: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const DisconnectStep2Preview: React.FC<DisconnectStep2PreviewProps> = ({
  selectedRequirement,
  selectedCompanyUnits,
  onRemove,
  onBack,
  onCancel,
  isLoading = false,
}) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const paperPadding = isMobile ? theme.spacing(2) : theme.spacing(3);

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          width: '100%',
          padding: paperPadding,
          backgroundColor: '#f7f0f1',
          display: 'flex',
          flexDirection: 'column',
          boxSizing: 'border-box',
        }}
      >
        {/* Law Section */}
        <Box style={{ display: 'flex', flexDirection: 'column', marginBottom: theme.spacing(2) }}>
          <Typography variant="body2" style={{ fontWeight: 600, marginBottom: theme.spacing(1) }}>
            {formatMessage({ id: 'law-portal.manage.law-list.table.law' })}
          </Typography>
          <Box
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px 14px',
              backgroundColor: '#fff',
              borderRadius: '4px',
            }}
          >
            <Box
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '40px',
                height: '40px',
                backgroundColor: '#e3f2fd',
                borderRadius: '6px',
                flexShrink: 0,
              }}
            >
              <DescriptionOutlinedIcon style={{ color: '#1976d2', fontSize: '24px' }} />
            </Box>
            <Box>
              <Typography variant="body2" style={{ fontWeight: 500, fontSize: '14px', color: '#222' }}>
                {selectedRequirement?.name}
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Company Units to Disconnect Section */}
        {selectedCompanyUnits.length > 0 && (
          <Box style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="body2" style={{ fontWeight: 600, marginBottom: theme.spacing(1) }}>
              {formatMessage({ id: 'law-portal.manage.company-units', defaultMessage: 'Company Units' })} ({selectedCompanyUnits.length})
            </Typography>
            <Box style={{ display: 'flex', flexDirection: 'column' }}>
              {selectedCompanyUnits.map((unit, idx) => (
                <Box
                  key={unit.id}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    padding: '12px 14px',
                    backgroundColor: '#fff',
                    borderRadius: '4px',
                    marginBottom: idx < selectedCompanyUnits.length - 1 ? theme.spacing(0.5) : 0,
                  }}
                >
                  <Box
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '40px',
                      height: '40px',
                      backgroundColor: PRIMARY,
                      borderRadius: '6px',
                      flexShrink: 0,
                    }}
                  >
                    <DescriptionOutlinedIcon style={{ color: '#fff', fontSize: '24px' }} />
                  </Box>
                  <Typography variant="body2" style={{ fontWeight: 500, fontSize: '14px', color: '#222' }}>
                    {unit.name}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        )}
      </div>

      <Box>
        <StepButtonBar
          onCancel={onCancel}
          onBack={onBack}
          onNext={onRemove}
          nextLabel="law-portal.delete-law.confirm-delete"
          nextDisabled={isLoading}
          isLoading={isLoading}
          formatMessage={formatMessage}
          showBack={true}
        />
      </Box>
    </div>
  );
};

export default DisconnectStep2Preview;
